import { adminSimulator as schemaAdminSimulator } from './schemas';
import apiClient from './apiClient';
import AdminSimulatorDataStore from '../../datastores/AdminSimulatorDataStore';

class AdminSimulatorDataStoreGraphQL implements AdminSimulatorDataStore {
  client = apiClient();

  async getStudentInformationById(studentCode: string) {
    try {
      const response = await this.client.query({
        query: schemaAdminSimulator.findStudentInformationByCode,
        variables: { studentCode }
      });
      const { studentByCode } = response.data?.administrator || {};
      return studentByCode;
    } catch (error) {
      throw new Error('error findStudentInformationByCode');
    }
  }
}

export default AdminSimulatorDataStoreGraphQL;
